// extracted by css-extract-rspack-plugin
export default {"Container":"rPEFA","headVariant":"Zd4RW","HeaderBreadcrumb":"PGwTJ","HeaderBreadcrumbs":"EtYGG"};